import React from 'react';
import { useTranslate } from '../../../mixins/translate/translate';
import { ConfirmRemoveDialog } from '../ConfirmDialog/ConfirmRemoveDialog';
import { IconButton } from './IconButton';

export function IconRemoveButton(props: { onClick: () => void; removeQuestion?: string }) {
    const translate = useTranslate();

    if (props.removeQuestion) {
        return <ConfirmRemoveDialog message={props.removeQuestion} onClick={() => props.onClick()} title={translate('common.remove')} />;
    }
    return <IconButton iconClass="fa-trash-o" onClick={props.onClick} title={translate('common.remove')} />;
}
